import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  categoryBtn: {
    '& svg': {
      marginTop: '-2px',
    },
    '&:hover, &:focus': {
      color: `rgb(${theme.palette.white})`,
      outline: 'none',
    },
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '0',
    boxSizing: 'border-box',
    color: `rgb(${theme.palette.gallery})`,
    display: 'inline-flex',
    fontSize: '0.875rem',
    fontWeight: '500',
    letterSpacing: '0.11em',
    lineHeight: '1.75',
    marginTop: '-16px',
    padding: '6px 8px',
    textTransform: 'uppercase',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    verticalAlign: 'middle',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-21px',
    },
  },
  categoryBtnText: {
    marginLeft: '0.5rem',
  },
}))

export default useStyles
